import React from 'react'
import { Outlet } from "react-router-dom"

import Head from "./Head"
import Footer from "./Footer"
import Body from "./Body"

import { CssBaseline } from "@mui/material"
import { ThemeProvider } from '@mui/material/styles'
import { theme } from './../themes/Light'

import "react-toastify/dist/ReactToastify.css"
import { ToastContainer } from 'react-toastify'

const Layout = () => {
    return (
        
        <ThemeProvider theme={theme} >
            <CssBaseline />
            <Head />
            <Body>
                <Outlet /> 
                <ToastContainer position={'bottom-right'} />
                
            </Body>
            <Footer />
        </ThemeProvider>
        
    )
}


export default Layout